import { useId } from 'react';
import type { ReactNode } from 'react';

/**
 * The signature image file input.
 *
 * A plain `<input type="file">` is used deliberately: the shared `Input` does not forward a
 * ref, and a file input needs its own id for the label and the hint.
 */
export function SignatureFileInput(props: {
  disabled: boolean;
  onFile: (file: File) => void;
}): ReactNode {
  const fileId = useId();
  return (
    <div className="space-y-2">
      <label htmlFor={fileId} className="block text-sm font-medium text-content">
        Signature image
      </label>
      <input
        id={fileId}
        type="file"
        accept="image/png,image/jpeg"
        disabled={props.disabled}
        aria-describedby={`${fileId}-hint`}
        className="block w-full text-sm text-content-muted file:mr-3 file:rounded-md file:border file:border-border file:bg-surface-raised file:px-3 file:py-1.5 file:text-sm file:text-content"
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) {
            props.onFile(file);
          }
        }}
      />
      <p id={`${fileId}-hint`} className="text-sm text-content-muted">
        PNG or JPEG, 2 MiB or smaller. This is a signature image, not a certificate-backed
        digital signature.
      </p>
    </div>
  );
}
